import { Employee } from "../../Objects/Employee/Employee"
import { PostFormRequest, PostRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useGetEmployee } from "./useGetEmployee"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"
import { JsonResponse } from "../../Objects/Generics/JsonResponse"

export const useSaveEmployee = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetEmployee } = useGetEmployee()

  const handleSaveEmployee = async (
    employeeChange: Employee,
    permissions: string[],
    onSuccess: any,
    imageFile?: any | null,
  ) => {
    try {
      enableLoad()

      var response = null

      if (employeeChange.employeeId !== -1) {
        response = await PutFormRequest<JsonResponse<number>>(
          `${API_ROUTES.EMPLOYEE.PUT}/${employeeChange.employeeId}`,
          employeeChange.toJSON(imageFile),
        )
      } else {
        response = await PostFormRequest<JsonResponse<number>>(
          API_ROUTES.EMPLOYEE.CREATE,
          employeeChange.toJSON(imageFile),
        )
      }

      if (response.success) {
        await handleSaveEmployeeRules(response.data, permissions, () => handleGetEmployee(onSuccess))

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const handleSaveEmployeeRules = async (id: number, permissions: string[], onSuccess: any) => {
    try {
      enableLoad()

      const params = new URLSearchParams()

      params.append("id", id.toString())

      var response = null

      response = await PostRequest(`${API_ROUTES.EMPLOYEE.RULES}?${params.toString()}`, {
        Permissions: permissions,
      })

      if (response.success) {
        onSuccess && onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSaveEmployee,
  }
}
